import { render, staticRenderFns } from "./EmployeesSliceDelete.vue?vue&type=template&id=4e3da9a9&scoped=true&"
import script from "./EmployeesSliceDelete.vue?vue&type=script&lang=js&"
export * from "./EmployeesSliceDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3da9a9",
  null
  
)

export default component.exports